import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-bloque',
  templateUrl: './bloque.component.html',
  styleUrls: ['./bloque.component.css']
})
export class BloqueComponent implements OnInit {
  @Input() bloque;
  @Input() global;
  constructor() { 
   
   }

  ngOnInit() { 
    this.global.idBloque = this.bloque.IdBloque;
  }

}
